import { dashBoardConstants } from '../../_constants/dashBoard.constants';
import { dashBoardService } from '../../_services/dashBoard/dashBoard.service';


export const dashBoardAction = {
    dashBoardAction1,
    assessorGroupListAction,
    invitePostAction,
    removeAssessmentAction,
    sendRemainderBulkAction,
    editAssesmentAction,
    sendRemainderIndividualAction,
    finalAssessments,
    getPdfAction
};

function dashBoardAction1(data, callback) {
    return dispatch => {
        dispatch(request());
        dashBoardService.dashBoardServiceApi(data)
            .then(
                dash_board_data => {
                    dispatch(success(dash_board_data));
                    if (callback) {
                        callback(dash_board_data)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_DASH_BOARD_DATA } }
    function success(dash_board_data) { return { type: dashBoardConstants.RECIEVE_DASH_BOARD_DATA, dash_board_data: dash_board_data } }
    function failure(error) { return { type: dashBoardConstants.ERROR_DASH_BOARD_DATA, error } }
}

function assessorGroupListAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.AssesserGroupList(data)
            .then(
                assessor_group_list => {
                    dispatch(success(assessor_group_list));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_ASSESSOR_GROUP_LIST } }
    function success(assessor_group_list) { return { type: dashBoardConstants.RECIEVE_ASSESSOR_GROUP_LIST, assessor_group_list: assessor_group_list } }
    function failure(error) { return { type: dashBoardConstants.ERROR_ASSESSOR_GROUP_LIST, error } }
}

function invitePostAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.invitePost(data)
            .then(
                invite_post => {
                    dispatch(success(invite_post));
                    let token = localStorage.getItem('access_token')

                    dispatch(dashBoardAction.dashBoardAction1(token))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_INVITE_POST } }
    function success(invite_post) { return { type: dashBoardConstants.RECIEVE_INVITE_POST, invite_post: invite_post } }
    function failure(error) { return { type: dashBoardConstants.ERROR_INVITE_POST, error } }
}

function removeAssessmentAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.removeAssessment(data)
            .then(
                remove_asessement => {
                    dispatch(success(remove_asessement));
                    let token = localStorage.getItem('access_token')

                    dispatch(dashBoardAction.dashBoardAction1(token))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_REMOVE_ASSESSMENT } }
    function success(remove_asessement) { return { type: dashBoardConstants.RECIEVE_REMOVE_ASSESSMENT, remove_asessement: remove_asessement } }
    function failure(error) { return { type: dashBoardConstants.ERROR_REMOVE_ASSESSMENT, error } }
}

function editAssesmentAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.editAssessment(data)
            .then(
                edit_asessement => {
                    dispatch(success(edit_asessement));
                    let token = localStorage.getItem('access_token')

                    dispatch(dashBoardAction.dashBoardAction1(token))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_EDTI_ASSESSMENT } }
    function success(edit_asessement) { return { type: dashBoardConstants.RECIEVE_EDTI_ASSESSMENT, edit_asessement: edit_asessement } }
    function failure(error) { return { type: dashBoardConstants.ERROR_EDTI_ASSESSMENT, error } }
}

function sendRemainderIndividualAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.sendRemainderIndividual(data)
            .then(
                send_remainder_individual => {
                    dispatch(success(send_remainder_individual));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: dashBoardConstants.REQUEST_SEND_REMAINDER_INDIVIDUAL } }
    function success(send_remainder_individual) { return { type: dashBoardConstants.RECIEVE_SEND_REMAINDER_INDIVIDUAL, send_remainder_individual: send_remainder_individual } }
    function failure(error) { return { type: dashBoardConstants.ERROR_SEND_REMAINDER_INDIVIDUAL, error } }
}

function sendRemainderBulkAction(data) {
    return dispatch => {
        dispatch(request());
        dashBoardService.sendRemainderBulk(data)
            .then(
                send_remainder_bulk => {
                    dispatch(success(send_remainder_bulk));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_SEND_REMAINDER_BULK } }
    function success(send_remainder_bulk) { return { type: dashBoardConstants.RECIEVE_SEND_REMAINDER_BULK, send_remainder_bulk: send_remainder_bulk } }
    function failure(error) { return { type: dashBoardConstants.ERROR_SEND_REMAINDER_BULK, error } }
}

function finalAssessments(data, callback) {
    return dispatch => {
        dispatch(request());
        dashBoardService.final_assessment_service(data)
            .then(
                final_assessment => {
                    dispatch(success(final_assessment))
                    callback()
                },
                error => {
                    dispatch(failure(error))
                }
            )
    };

    function request() { return { type: dashBoardConstants.REQUEST_FINAL_ASSESSMENTS } }
    function success(final_assessment) { return { type: dashBoardConstants.RECIEVE_FINAL_ASSESSMENTS, final_assessment } }
    function failure(error) { return { type: dashBoardConstants.ERROR_FINAL_ASSESSMENTS, error } }
}

function getPdfAction(data, key, callback) {
    return dispatch => {
        dispatch(request());
        dashBoardService.get_pdf(data, key)
            .then(
                get_pdf => {

                    dispatch(success(get_pdf));
                    callback(get_pdf)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: dashBoardConstants.REQUEST_PDF } }
    function success(get_pdf) { return { type: dashBoardConstants.RECIEVE_PDF, get_pdf: get_pdf } }
    function failure(error) { return { type: dashBoardConstants.ERROR_PDF, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/dashBoard/dashBoardActions.js